import { render, staticRenderFns } from "./vgs.vue?vue&type=template&id=00dd5cd6&scoped=true&"
import script from "./vgs.vue?vue&type=script&lang=ts&"
export * from "./vgs.vue?vue&type=script&lang=ts&"
import style0 from "./vgs.vue?vue&type=style&index=0&id=00dd5cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd5cd6",
  null
  
)

export default component.exports